/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Filter_To_DateInputs */

const en_audit_filter_to_date = /** @type {(inputs: Audit_Filter_To_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To date`)
};

const pt_br2_audit_filter_to_date = /** @type {(inputs: Audit_Filter_To_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data final`)
};

/**
* | output |
* | --- |
* | "To date" |
*
* @param {Audit_Filter_To_DateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const audit_filter_to_date = /** @type {((inputs?: Audit_Filter_To_DateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Filter_To_DateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_filter_to_date(inputs)
	return pt_br2_audit_filter_to_date(inputs)
});